import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarCollapsed(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // 초기 상태 설정

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <footer className={`max-w-[2560px] w-full mx-auto block ${isSidebarCollapsed ? 'ml-[60px]' : 'ml-[250px]'}`}>
      <div className="bg-white border-t border-t-[#b8c1cc63]">
        <div className="relative max-w-[1440px] w-full mx-auto py-[26px] px-[24px] mobile:px-4">
          <div className='mobile__footer--hidden--pc'>
            <div className="flex items-center">
              <NavLink to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/logo/logo.png`}
                  alt="Creator Store"
                  className="w-[71px] h-auto object-cover"
                />
              </NavLink>
              <NavLink
                to="/service"
                className="text-sm text-[#999] font-medium ml-4"
              >
                {t('termsOfService')}
              </NavLink>
              <NavLink
                to="/privacypolicy"
                className="text-sm text-[#999] font-medium ml-4"
              >
                {t('privacyPolicyTitle')}
              </NavLink>
            </div>

            {/* 기본정보 */}
            <p className="mt-3">
              <span className="text-[#787893] text-xs">
                {t('businessName')} : 크리에이터유닛스튜디오
              </span>
              <span className="footer_after">
                {t('businessRegistrationNumber')} : 346-09-02076
              </span>
              <span className="footer_after">
                {t('representative')} : 신준
              </span>
              <span className="footer_after">
                {t('businessAddress')} : 서울특별시 마포구 월드컵로15길 86. 3층
              </span>
              <span className="footer_after">
                {t('phonenumber')} : +8210-5613-1571
              </span>
            </p>
          </div>

          {/* mobile.ver */}
          <div className='mobile__footer'>
            <div className="footer__mobile--item">
              <NavLink to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/logo/logo.png`}
                  alt="Creator Store"
                  className="w-[71px] h-auto object-cover"
                />
              </NavLink>
              <NavLink
                to="/service"
                className="text-sm text-[#999] font-medium ml-4 mobile:ml-0 mobile:leading-6"
              >
                {t('termsOfService')}
              </NavLink>
              <NavLink
                to="/privacypolicy"
                className="text-sm text-[#999] font-medium ml-4 mobile:ml-0 mobile:leading-6"
              >
                {t('privacyPolicyTitle')}
              </NavLink>
            </div>
            {/* 기본정보 */}
            <p className="mt-3 footer__mobile--item">
              <span className="footer__mobile--item--info">
                {t('businessName')} : 크리에이터유닛스튜디오
              </span>
              <span className="footer__mobile--item--info">
                {t('businessRegistrationNumber')} : 346-09-02076
              </span>
              <span className="footer__mobile--item--info">
                {t('representative')} : 신준
              </span>
              <span className="footer__mobile--item--info">
                {t('businessAddress')} : 서울특별시 마포구 월드컵로15길 86. 3층
              </span>
              <span className="footer__mobile--item--info">
                {t('phonenumber')} : +8210-5613-1571
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
